import { useParams } from 'react-router-dom';
import useNav from './useNav';
import { useRecoilState } from 'recoil';
import * as Atom from "../../application/recoil";

import useTermsBloc from './useTermsBloc';
import { EVENT_REQUEST } from '../types/types';
import { useState } from 'react';
import { fetchSelectTempPreRequest } from '../../infra/api/mtg/fetchSelectTempPreRequst';
import { useBaseParam } from './useBaseParam';
import {isIOS} from "react-device-detect";

interface ITermPayload {
  EVENT_PAGE?: string;
  EVENT_REQUEST?: string;
  EVENT_STATE?: string | {};
  EVENT_OPTION?: any;
}

export const useTerms = (props?: any) => {
  const { navigate } = useNav();
  const { media } = useParams();
  const { show, agree }: any = useTermsBloc(media, props?.ref_page);
  const [personal, setPersonal] = useRecoilState(Atom.personalInfo);
  const [lguIOSWarning, setLguIOSWarning] = useRecoilState(Atom.lguIOSWarning);

  const showTerm = async (service?: ITermPayload) => {
    if (media === 'lgu') {
      await processAgreeTermLgu(undefined, service);
    } else {
      navigateTerm(service);
    }
  };

  // const showTermBottomsheet = async (service?: ITermPayload) => {
  //   if (media === 'lgu') {
  //     await processAgreeTermLgu();
  //   } else {
  //     return
  //   }
  // };

  // 클릭 -> 약관페이지 -> step1
  // 클릭 -> 약관동의(lgu) -> step1
  const processAgreeTerm = async () => {
    if (media !== 'lgu') {
      const res = await agree();
      if (res.isSuccess) {
        if (props?.EVENT_REQUEST === EVENT_REQUEST.AGREE) {
          await (props?.EVENT_EXECUTE && props.EVENT_EXECUTE(res.custSeq));
        }
        navigateStep1();
      }
    }
  };

  const processAgreeTermAndNavigate = async (path: string, navigationOption?: any) => {
    if (media !== 'lgu') {
      const res = await agree();
      if (res.isSuccess) {
        if (props?.EVENT_REQUEST === EVENT_REQUEST.AGREE) {
          await (props?.EVENT_EXECUTE && props.EVENT_EXECUTE(res.custSeq));
        }
        navigate(path, navigationOption);
      }
    }
  }

  const processAgreeTermLgu = async (callback?: () => {}, state?: any) => {
    if (media === 'lgu') {
      const res: any = await show(state);
      if (typeof res !== 'object') {
        return;
      } else if (res.isSuccess) {
        await (callback ? callback() : Promise.resolve());
        navigateStep1(state);
      }
    }
  };

  const processAgreeTermLgu2 = async (callback?: () => void) => {
    if (media === 'lgu') {
      const res: any = await show();
      if (typeof res !== 'object') {
        return;
      } else if (res.isSuccess) {
        await (callback ? callback() : Promise.resolve());
      }
    }
  };

  const navigateTerm = (payload?: ITermPayload) => {
    navigate('/term', { state: payload});
  };

  const [showReuse, setShowReuse] = useState(false);
  const showReuseSheet = () => {
    setShowReuse(true);
  };

  const fetchDraft = useBaseParam(fetchSelectTempPreRequest, { custSeq: personal.custSeq});
  const goToNextOfMtg = async () => {
    // TODO 상태를 봐서 이어서 입력하기 여부 확인
    if (media !== "lgu") {
      const res = await fetchDraft();
      if (res.data.result && res.data.result.tempResult && res.data.result.tempResult.preRequestSeq > 0) {
        showReuseSheet();
      } else {
        navigate(`/mtg/conditions/1`,  {state: {ref_page: "/terms"}});
      }
    } else {
      navigate(`/mtg/conditions/1`,  {state: {ref_page: "/terms"}});
    }
  }

  const navigateStep1 = (state?: any) => {
    
    if (props?.EVENT_STATE === 'mtg' || state?.EVENT_STATE === 'mtg') {
      goToNextOfMtg();
      return;
    }
    const path =
      process.env.REACT_APP_ENV !== 'production'
        ? '/conditions/2'
        : '/conditions/1';
    navigate(path, { state: state?.EVENT_STATE ?? props?.EVENT_STATE ?? '' });
  };

  return {
    showTerm,

    processAgreeTerm,
    processAgreeTermAndNavigate,
    processAgreeTermLgu,
    processAgreeTermLgu2,

    navigateStep1,
    navigateTerm,

    showReuse,
    setShowReuse,
  };
};
